export enum OptionsMealPlanTableEmitEnum {
  SHOW = 'SHOW',
  USE = 'USE',
  DOWNLOAD = 'DOWNLOAD',
  DELETE = 'DELETE'
}
